import { useState } from "react";

export const CHAIN_LENGTH_OPTIONS = [
  {
    label: "100",
    value: "1",
    id: "4B1",
    chainId: null,
    accessoryKey: null,
    className: "no_surcharge_price",
  },
  {
    label: "150",
    value: "2",
    id: "4B11",
    chainId: null,
    accessoryKey: null,
    className: "no_surcharge_price",
  },
  {
    label: "200",
    value: "3",
    id: "4B2",
    chainId: "90908903",
    accessoryKey: "70",
    className: "surcharge_price 2",
  },
  {
    label: "250",
    value: "4",
    id: "4B3",
    chainId: "90908904",
    accessoryKey: "71",
    className: "surcharge_price 3",
  },
  {
    label: "300",
    value: "5",
    id: "4B21",
    chainId: "90908901",
    accessoryKey: "2",
    className: "surcharge_price 2",
  },
  {
    label: "500",
    value: "6",
    id: "4B31",
    chainId: "90908902",
    accessoryKey: "3",
    className: "surcharge_price 3",
  },
];

export const getChainLengthOption = (label) =>
  CHAIN_LENGTH_OPTIONS.find((opt) => opt.label === label?.toString());

const getChainLengthPriceContent = (
  item,
  t,
  modelAccessories,
  GetPrice,
  pageLanguage,
  isTabletOrMobile
) => {
  if (item.accessoryKey === null) {
    return t("No extra charge");
  }

  const prefix =
    Object.keys(modelAccessories).length !== 0 ? "" : pageLanguage === "en" ? t("Surcharge Applies") : t("Surcharge Applies2");

  const pricePart =
    modelAccessories["2"] && modelAccessories["2"][item.accessoryKey]
      ? GetPrice(
          modelAccessories["2"][item.accessoryKey]["Price"],
          pageLanguage,
          t("TOMANS"),
          isTabletOrMobile
        )
      : null;

  return `${prefix}${pricePart ?? ""}`;
};

const ChainLengthSelector = ({
  t,
  step4B,
  setStep4B,
  setChainLengthId,
  setDeps,
  selectChanged,
  setCart,
  inputs,
  modelAccessories,
  GetPrice,
  pageLanguage,
  isTabletOrMobile,
  sectionTitle,
}) => {
  const options = CHAIN_LENGTH_OPTIONS;
  const [expanded, setExpanded] = useState(false);
  const selectedOption = getChainLengthOption(step4B);
  const headerTitle = sectionTitle ?? t("zebra_step4B");

  return (
    <div className="checkout_shipping_card chain_length_selector_card">
      <div className="checkout_shipping_row">
        <button
          type="button"
          className="checkout_shipping_row_inner"
          aria-expanded={expanded}
          aria-controls="chain-length-selector-content"
          onClick={() => setExpanded((prev) => !prev)}
        >
          {/* <h2 className="checkout_ship_to_label">{headerTitle}</h2> */}
          <div
            className={`checkout_shipping_summary${
              selectedOption ? "" : " checkout_shipping_summary_empty"
            }`}
            style={{ fontWeight: "400" , color: "#49443e" }}
          >
            {selectedOption ? (
              <>
              <span
               className="checkout_shipping_summary_sep"
               style={{  fontWeight: "400" , color: "#49443e" }}
               >
              {headerTitle}
              </span>
              <span style={{  fontWeight: "400" , color: "#49443e" , padding: "0 0.5rem" }}>

                {t(`${selectedOption.label}cm`)}
                <span style={{padding: "0 0.1rem"}}>
              
                </span>
                <span>
              (
                {getChainLengthPriceContent(
                  selectedOption,
                  t,
                  modelAccessories,
                  GetPrice,
                  pageLanguage,
                  isTabletOrMobile
                )}
              )
                </span>
              </span>
              
             
              </>
            ) : (
              t("please_select_chain_length")
            )}
          </div>
          <span className="checkout_ship_to_label"></span>
           
          <span className="checkout_shipping_toggle">
            <svg viewBox="0 0 14 14" focusable="false" aria-hidden="true">
              <path
                d="M3.5 5.5L7 9l3.5-3.5"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </span>
        </button>
      </div>
      {expanded && (
        <div id="chain-length-selector-content" className="checkout_shipping_content">
          <div className="checkout_shipping_options" role="radiogroup">
            {options.map((item) => {
              const isSelected = step4B === item.label;
              const priceText = getChainLengthPriceContent(
                item,
                t,
                modelAccessories,
                GetPrice,
                pageLanguage,
                isTabletOrMobile
              );
       

              return (
                <div
                  key={item.id}
                  className={`checkout_shipping_option${isSelected ? " selected" : ""}`}
                >
                  <div className="checkout_shipping_option_label">
                    <div className="radio_style radio_style_type checkout_shipping_radio">
                      <input
                        className="radio"
                        type="radio"
                        text={t(`${item.label}cm`)}
                        value={item.value}
                        name="step4B"
                        ref-num="4B"
                        id={item.id}
                        checked={isSelected}
                        onChange={(e) => {
                          setStep4B(item.label);
                          setChainLengthId(item.chainId);
                          setDeps("", "4B");
                          selectChanged(e);
                          setCart("ChainLength", item.label);
                          // setTimeout(() => {
                          //   setExpanded(false);
                          // }, 4000);
                          setExpanded(false);
                        }}
                        ref={(ref) => (inputs.current[item.id] = ref)}
                      />
                      <label
                        htmlFor={item.id}
                        className="checkout_shipping_option_text"
                        style={{ paddingTop: "0" }}
                      >
                        <span className="checkout_shipping_option_name" style={{ marginTop: "3px" , fontWeight: "400" , color: "#49443e" }}>
                          {t(`${item.label}cm`)}
                        </span>
                      </label>
                    </div>
                    <span
                      className={`surcharge_price  ${item.className}`}
                    >
                  {pageLanguage === "en" &&( priceText === "No extra charge" || priceText === "Surcharge Applies" ? priceText === "No extra charge" ? t("(No extra charge)") : priceText : t("Add") + " " + priceText)}
                  {pageLanguage === "fa" &&( priceText === "بدون هزینه" || priceText === "هزینه اضافه می‌شود" ? priceText === "بدون هزینه" ? t("(بدون هزینه)") : "هزینه اضافه می‌شود" : t("Add") + " " + priceText)}
                      
                    </span>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
};

export default ChainLengthSelector;
